import React from "react";
import { Box, Typography } from "@mui/material";
import QueryChatPage from "./QueryChatPage";

// Same logo assets as NewKijabeChatPage (Ask Me Anything shell)
// eslint-disable-next-line import/no-unresolved -- assets path resolved at build
import amhLogo from "../../assets/images/logos/amhlearn-logo.png";
// eslint-disable-next-line import/no-unresolved -- assets path resolved at build
import kijabeLogo from "../../assets/images/logos/kijabe-logo.png";

/**
 * Ask Me Anything 2: same header/images as /ask-me-anything but uses the Query Manager
 * chatbot (ama-kijabe-1) so behavior matches /chatbot/ama-kijabe-1.
 */
const AskMeAnything2Page = () => (
  <Box sx={{ maxWidth: 900, mx: "auto", width: "100%", py: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        mb: 3,
      }}
    >
      <img src={amhLogo} alt="AMH" style={{ height: 45 }} />
      <Typography color="text.secondary" sx={{ mx: 1 }}>
        ×
      </Typography>
      <img src={kijabeLogo} alt="Kijabe" style={{ height: 45 }} />
    </Box>
    <QueryChatPage overrideQueryId="ama-kijabe-1" compactLayout />
  </Box>
);

export default AskMeAnything2Page;
